import React from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import AdminShell from '../../features/admin/components/AdminShell';
import AdminCustomersPage from '../../features/admin/pages/AdminCustomersPage';
import AdminDashboardPage from '../../features/admin/pages/AdminDashboardPage';
import AdminVoucherCreatePage from '../../features/admin/pages/AdminVoucherCreatePage';
import AdminVoucherListPage from '../../features/admin/pages/AdminVoucherListPage';
import AdminVoucherRedeemPage from '../../features/admin/pages/AdminVoucherRedeemPage';
import AdminVoucherDetailPage from '../../features/admin/pages/AdminVoucherDetailPage';
import ProtectedRoute from '../../features/auth/components/ProtectedRoute';
import LoginPage from '../../features/auth/pages/LoginPage';
import RegisterPage from '../../features/clients/pages/RegisterPage';
import CookiesPolicyPage from '../../features/cookies/pages/CookiesPolicyPage';
import LegalNoticePage from '../../features/legal/pages/LegalNoticePage';
import PrivacyPolicyPage from '../../features/legal/pages/PrivacyPolicyPage';
import TermsAndConditionsPage from '../../features/legal/pages/TermsAndConditionsPage';
import BirthdaysPage from '../../features/marketing/pages/BirthdaysPage';
import LandingPage from '../../features/marketing/pages/LandingPage';
import RestrictionPage from '../../features/marketing/pages/RestrictionPage';
import ProfilePage from '../../features/users/pages/ProfilePage';
import UserManagementPage from '../../features/users/pages/UserManagementPage';
import VoucherLookupPage from '../../features/vouchers/pages/VoucherLookupPage';
import { ROUTES } from '../../shared/config/routes';
import MainLayout from '../../shared/layouts/MainLayout';

function ScrollToHash() {
  const location = useLocation();

  React.useEffect(() => {
    if (!location.hash) {
      return;
    }

    const id = location.hash.replace('#', '');
    const attemptScroll = () => {
      const element = document.getElementById(id);
      if (!element) {
        return false;
      }

      const top = Math.max(element.getBoundingClientRect().top + window.scrollY - 96, 0);
      window.scrollTo({ top, behavior: 'smooth' });
      return true;
    };

    if (attemptScroll()) {
      return undefined;
    }

    const timeoutId = window.setTimeout(attemptScroll, 120);
    return () => window.clearTimeout(timeoutId);
  }, [location.hash, location.pathname]);

  return null;
}

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <ScrollToHash />
      <Routes>
        <Route element={<MainLayout />}>
          <Route path={ROUTES.home} element={<LandingPage />} />
          <Route path={ROUTES.register} element={<RegisterPage />} />
          <Route path={ROUTES.birthdays} element={<BirthdaysPage />} />
          <Route path={ROUTES.terms} element={<TermsAndConditionsPage />} />
          <Route path={ROUTES.restriction} element={<RestrictionPage />} />
          <Route path={ROUTES.login} element={<LoginPage />} />
          <Route path={ROUTES.voucherLookup} element={<VoucherLookupPage />} />
          <Route path={ROUTES.cookiesPolicy} element={<CookiesPolicyPage />} />
          <Route path={ROUTES.legalNotice} element={<LegalNoticePage />} />
          <Route path={ROUTES.privacyPolicy} element={<PrivacyPolicyPage />} />
          <Route
            path={ROUTES.admin}
            element={(
              <ProtectedRoute>
                <AdminShell />
              </ProtectedRoute>
            )}
          >
            <Route index element={<AdminDashboardPage />} />
            <Route path="clientes" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><AdminCustomersPage /></ProtectedRoute>} />
            <Route path="bonos" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><AdminVoucherListPage /></ProtectedRoute>} />
            <Route path="bonos/crear" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><AdminVoucherCreatePage /></ProtectedRoute>} />
            <Route path="bonos/canjear" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><AdminVoucherRedeemPage /></ProtectedRoute>} />
            <Route path="bonos/:voucherId" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><AdminVoucherDetailPage /></ProtectedRoute>} />
            <Route path="perfil" element={<ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}><ProfilePage /></ProtectedRoute>} />
            <Route path="usuarios" element={<ProtectedRoute allowedRoles={['ADMIN']}><UserManagementPage /></ProtectedRoute>} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
